module.exports = __webpack_public_path__ + "img/four_content_item_bg_03.0ae05ad6.png";